import type { SoundId } from './sounds'
import { playSoundUntilFinished } from '@/src/utils/soundPlayer'

const CHARACTER_CRASH_SOUNDS = [
    'characterCrash1',
    'characterCrash2',
    'characterCrash3',
] as const satisfies readonly SoundId[]

export function playCharacterCrashSoundUntilFinished(isFinalLife = false): Promise<void> {
    const soundId = isFinalLife
        ? 'characterCrashFinal'
        : CHARACTER_CRASH_SOUNDS[Math.floor(Math.random() * CHARACTER_CRASH_SOUNDS.length)]

    return playSoundUntilFinished(soundId)
}
